import { SyntheticEvent, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { TabsPanel } from 'design-system/TabPanel/TabPanel';

import PageTopBar from 'components/Topbar/PageTopBar';

import '../view.scss';

export enum EReportsTabs {
  FINANCIAL = 'financialreports',
  PAYOUTS = 'payouts'
}

const ReportsView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const basePath = location.pathname.split('/reports')[0];

  const getInitialActiveTab = () => {
    const path = location.pathname;
    if (path.includes(EReportsTabs.PAYOUTS)) return EReportsTabs.PAYOUTS;
    return EReportsTabs.FINANCIAL;
  };

  const [activeTab, setActiveTab] = useState(getInitialActiveTab());

  useEffect(() => {
    setActiveTab(getInitialActiveTab());
  }, [location.pathname]);

  const handleTabChange = (e: SyntheticEvent, value: EReportsTabs) => {
    setActiveTab(value);
    navigate(`${basePath}/reports/${value}`);
  };

  const tabs = [
    { label: 'Financial', value: EReportsTabs.FINANCIAL },
    { label: 'Payouts', value: EReportsTabs.PAYOUTS }
  ];

  return (
    <TabsPanel
      tabs={tabs}
      headerComponent={<PageTopBar withTabsDesign={true} headline="Reports" />}
      handleTabChange={handleTabChange}
      activeTabVal={activeTab}
    />
  );
};

export default ReportsView;
